import { ENUM__redux_action } from '@/state/_base/ENUM__redux_action';
import { PayloadAction } from '@reduxjs/toolkit';
import { DTOWorkspaceChildEntityViewer } from '@shared/dto/+workspace/workspace_entity/dto_workspace_child_entity_viewer';
import { STATE__workspace } from '../STATE__workspace';

export const local_workspace_child_entity_child_viewer_upsert = (payload: DTOWorkspaceChildEntityViewer[]): PayloadAction<DTOWorkspaceChildEntityViewer[]> => ({
  type: ENUM__redux_action.WORKSPACE_CHILD_ENTITY_VIEWER_UPSERT,
  payload,
});

export const init_local_workspace_child_entity_child_viewer_upsert = (state: STATE__workspace, action: PayloadAction<DTOWorkspaceChildEntityViewer[]>) => {
  if (action.payload.is_empty()) return;

  for (let visitor of action.payload) {
    state.child_entity_viewers_map.set(visitor.get_viewer_id(), visitor);
  }

  //refresh map to trigger re-render
  state.child_entity_viewers_map = new Map(state.child_entity_viewers_map);
};
